import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function ViewersBar() {
  const [viewers, setViewers] = useState(89);
  const [visible, setVisible] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  // Show on scroll down, hide on scroll up
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      if (currentY > 120) {
        setVisible(currentY > lastScrollY ? true : false);
      } else {
        setVisible(false);
      }
      setLastScrollY(currentY);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);
  // Fluctuate viewer count
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(prev => {
        const delta = Math.floor(Math.random() * 5) - 2;
        const next = prev + delta;
        return Math.max(72, Math.min(134, next));
      });
    }, 3500);
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-665">
      {visible && <motion.div initial={{
      y: 60,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 60,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-[1400] flex justify-center pb-3 px-4 pointer-events-none" data-id="element-666">
          <div className="bg-[#2C1810]/90 backdrop-blur-sm text-white rounded-full px-5 py-2.5 flex items-center gap-2.5 shadow-[0_4px_20px_rgba(0,0,0,0.25)] pointer-events-auto border border-white/10" data-id="element-667">
            <span className="relative flex h-2.5 w-2.5 shrink-0" data-id="element-668">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#4ADE80] opacity-75" data-id="element-669"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#22C55E]" data-id="element-670"></span>
            </span>
            <span className="text-xs font-medium text-white/90" data-id="element-671">
              <span className="font-bold text-white" data-id="element-672">{viewers} personas</span>{' '}
              están viendo esta página ahora
            </span>
          </div>
        </motion.div>}
    </AnimatePresence>;
}